import React, { useState } from 'react';
import { adminPricingService } from '../../../services/adminService';

const UpdatePricingModal = ({ inspection, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    selling_price: inspection.estimated_price || '',
    condition_grade: inspection.overall_rating || '',
    price_reason: inspection.condition_report || ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.selling_price || !formData.condition_grade || !formData.price_reason) {
      alert('Please fill all required fields');
      return;
    }

    try {
      setSubmitting(true);
      await adminPricingService.createPricing(inspection.id, formData);
      alert('✅ Pricing updated successfully!');
      onSuccess();
    } catch (error) {
      console.error('Pricing error:', error);
      alert('Failed to update pricing: ' + (error.response?.data?.message || error.message));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content pricing-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            🔥 {inspection.estimated_price ? 'Update' : 'Set'} Pricing - Inspection #{inspection.id}
          </h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          {/* Car Summary */}
          <div className="pricing-summary">
            <div className="car-info-header">
              <h3>
                {inspection.sell_request?.brand} {inspection.sell_request?.model} {inspection.sell_request?.year}
              </h3>
              <p className="car-meta">
                📍 • 🚗 {inspection.sell_request?.km_driven?.toLocaleString()} km • 
                {inspection.inspection_type === 'branch' ? ' 🏢' : ' 🏠'} {inspection.inspection_type}
              </p>
            </div>

            {/* Inspection Highlights */}
            {inspection.inspection_report && (
              <div className="inspection-highlights">
                <div className="highlight-item score">
                  <span className="label">Inspection Score</span>
                  <span className="value">{inspection.inspection_report.overall_score}/10</span>
                </div>
                <div className="highlight-item">
                  <span className="label">Flood Status</span>
                  <span className={`value ${!inspection.inspection_report.flooded ? 'success' : 'danger'}`}>
                    {inspection.inspection_report.flooded ? '❌ Flooded' : '✅ Not Flooded'}
                  </span>
                </div>
                <div className="highlight-item">
                  <span className="label">Meter Status</span>
                  <span className={`value ${!inspection.inspection_report.meter_tampered ? 'success' : 'danger'}`}>
                    {inspection.inspection_report.meter_tampered ? '❌ Tampered' : '✅ Meter OK'}
                  </span>
                </div>
              </div>
            )}
          </div>

          {/* Pricing Form */}
          <form onSubmit={handleSubmit} className="pricing-form">
            <div className="form-row">
              <div className="form-group">
                <label>Selling Price (₹) *</label>
                <input
                  type="number"
                  value={formData.selling_price}
                  onChange={(e) => setFormData({ ...formData, selling_price: e.target.value })}
                  placeholder="350000.0"
                  className="form-input price-input"
                  required
                  min="0"
                  step="1000"
                />
                <small>Set competitive price based on inspection report and market value</small>
              </div>

              <div className="form-group">
                <label>Condition Grade *</label>
                <select
                  value={formData.condition_grade}
                  onChange={(e) => setFormData({ ...formData, condition_grade: e.target.value })}
                  className="form-select"
                  required
                >
                  <option value="">Select Grade</option>
                  <option value="Excellent">Excellent (9-10/10)</option>
                  <option value="Good">Good (7-8/10)</option>
                  <option value="Fair">Fair (5-6/10)</option>
                  <option value="Poor">Poor (Below 5/10)</option>
                </select>
                <small>Grade should match the inspection score range</small>
              </div>
            </div>

            <div className="form-group">
              <label>Price Justification *</label>
              <textarea
                value={formData.price_reason}
                onChange={(e) => setFormData({ ...formData, price_reason: e.target.value })}
                placeholder="Explain pricing rationale based on inspection findings, market value, car condition, etc..."
                rows="5"
                className="form-textarea"
                required
              />
              <small>This detailed justification will be sent to the seller along with the offer</small>
            </div>
          </form>
        </div>

        <div className="modal-footer">
          <button 
            type="button" 
            className="btn-modal-cancel" 
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn-modal-submit"
            onClick={handleSubmit}
            disabled={submitting || !formData.selling_price || !formData.condition_grade || !formData.price_reason}
          >
            {submitting ? '⏳ Submitting...' : `🔥 ${inspection.estimated_price ? 'Update' : 'Submit'} Pricing`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePricingModal;